module.exports = __webpack_public_path__ + "static/assets/1c1e88a958ba45c243b030c0bd079869.gif";